import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import DataComponentFinanceBlock from "../../../DataComponent/DataComponentFinanceBlock";
import UserStore from "../../../../stores/UserStore";
import { useI18n } from 'utils/I18n/context';

const FinanceReportList = ({ 
    total: propTotal, 
    page: propPage, 
    loading: propLoading,
    headerNames,
    list: propList,
    getFinanceOperations,
    selectedOptions
}) => {
    const { t } = useI18n();

    const [list, setList] = useState([]);
    const [totalPages, setTotalPages] = useState(propTotal);
    const [loading, setLoading] = useState(propLoading);

    const staticNameTable = t?.dataTable || {};
    const staticNameFinanceOperations = t?.financeReportPage?.financeItem || {};

    useEffect(() => {
        if (propList && headerNames) {
            const filteredList = [];
            for (let financeOperations of propList) {
                let financeOperationsFiltred = {};
                let pushFinanceOperations = false;
                for (let dataField in financeOperations) {
                    const header = headerNames.find(header => header.keyTitle === dataField);
                    if (header && header.visible) {
                        financeOperationsFiltred[dataField] = financeOperations[dataField];
                        if (!pushFinanceOperations) {
                            pushFinanceOperations = true;
                        }
                    }
                }
                if (pushFinanceOperations) {
                    filteredList.push(financeOperationsFiltred);
                }
            }

            setList(filteredList);
            setTotalPages(propTotal);
            setLoading(propLoading);
        }
    }, [propList, propTotal, propPage, propLoading, headerNames]);

    const onDataTableAction = useCallback((state, actionType) => {
        if (actionType === 'firstRender') return;
        if (getFinanceOperations) {
            const stateWithUserId = { ...state, user_id: UserStore.getID() };
            getFinanceOperations(stateWithUserId);
        }
    }, [getFinanceOperations]);

    const onResetFilter = useCallback((state) => {
        if (getFinanceOperations) {
            const stateWithUserId = { ...state, user_id: UserStore.getID() };
            getFinanceOperations(stateWithUserId);
        }
    }, [getFinanceOperations]);

    const currencies = selectedOptions ? selectedOptions() : [];

    return (
        <div className="history-postback__table">
            <DataComponentFinanceBlock
                onAction={onDataTableAction}
                onReset={onResetFilter}
                page={propPage}
                totalPages={totalPages}
                headerNames={headerNames}
                data={list}
                loading={loading}
                isQuery={true}
                settings={true}
                settingKey={'financeOperations'}
                tableBodyTitle={staticNameFinanceOperations}
                className="report-table simple-table report-table_last"
                gray={true}
                fields={[
                    {
                        name: 'dynamic',
                        key: 'period',
                        segment: 'Period',
                        label: staticNameTable?.headers?.periodTitle,
                        dropdownLabel: staticNameTable?.filter,
                        withList: true,
                        value: [{ title: t?.dataTable?.all || 'All', value: 'all' }]
                    },
                    {
                        name: 'dropdown',
                        key: 'currency',
                        segment: 'Currency',
                        data: currencies,
                        label: staticNameTable?.headers?.currency,
                        dropdownLabel: staticNameTable?.filter
                    }
                ]}
            />
        </div>
    );
};

FinanceReportList.propTypes = {
    total: PropTypes.number,
    page: PropTypes.number,
    loading: PropTypes.bool,
    headerNames: PropTypes.array,
    list: PropTypes.array,
    getFinanceOperations: PropTypes.func,
    selectedOptions: PropTypes.func
};

FinanceReportList.defaultProps = {
    total: 0,
    page: 1,
    loading: false,
    headerNames: [],
    list: [],
    getFinanceOperations: () => {},
    selectedOptions: () => []
};

export default FinanceReportList;
